import { S as Swiper } from './swiper-core-BtjM6e_D.js';
import { M as Mousewheel } from './mousewheel-h0xfRusx.js';
import { A as A11y } from './a11y-BYUO09Sv.js';

class CollectionNavigation extends HTMLElement {
  swiper = this.querySelector('.swiper');
  visual_config = {
    slidesPerView: 2.8,
    spaceBetween: 2,
    breakpoints: {
      768: { slidesPerView: 4 },
      1024: { slidesPerView: 6 },
    },
  };
  default_config = {
    slidesPerView: 'auto',
    slidesOffsetAfter: -24,
  };

  getVariantConfig = (navStyle) =>
    navStyle === 'visual' ? this.visual_config : this.default_config;

  connectedCallback() {
    if (!this.swiper) return;

    this.swiperInstance = new Swiper(this.swiper, {
      modules: [A11y, Mousewheel],
      mousewheel: {
        enabled: true,
        releaseOnEdges: true,
      },
      ...this.getVariantConfig(this.dataset.navStyle),
    });
  }

  disconnectedCallback() {
    this.swiperInstance?.destroy(true, true);
  }
}

customElements.define('collection-navigation', CollectionNavigation);
